import Money from '../money';

interface CashPriceProps {
  amount: number;
  prefix?: string | React.ReactNode;
  suffix?: string;
}

const CashPrice = ({ amount, prefix = 'Only', suffix }: CashPriceProps) => {
  return (
    <span className="ac-pricing__cash ch-align-items--center">
      <span className="ac-pricing__prefix">{prefix}</span>
      <Money amount={amount} />
      {suffix && <span className="ac-pricing__suffix">{suffix}</span>}
    </span>
  );
};

export default CashPrice;
